import mitt from 'mitt'

const emitter = mitt()

function useEventEmitter() {
  return emitter
}

export default useEventEmitter
